window.quantites = []
document.addEventListener("DOMContentLoaded", function() {
 let variant_selectors = document.querySelectorAll('.test_select');
 variant_selectors.forEach((variant_selector) => {
    variant_selector.addEventListener('change', () => {
        for(let i = 0; i < variant_selector.children.length; i++){
            let child  = variant_selector.children[i];
            child.removeAttribute('selected')
        }
        variant_selector.children[variant_selector.selectedIndex].setAttribute('selected','')
        variant_selector.style.display = "none"

        let quantity_selector = variant_selector.previousElementSibling;
        quantity_selector.style.display = "block";
        quantity_selector.dataset.variant = variant_selector.children[variant_selector.selectedIndex].dataset.variantid
        window.BundleInfo.push(bundleProduct(quantity_selector.dataset.variant,quantity_selector.dataset.img,Number(variant_selector.children[variant_selector.selectedIndex].dataset.price)/100,1))
        updatSelectedData();
    })
 })

 let options = document.querySelectorAll('.variant_option');

 options.forEach((option) => {
    quantites.push({variantId: option.dataset.variantid, quantity: Number(option.dataset.max)})
 })

  window.originalHeaderText = "";
});

function AddProductToBundle(self,isImg){
    if(isImg){
        let parent = self.parentElement;
        let quantity_selector = parent.querySelector(".quantity-control");

        if(isInBundle(quantity_selector.dataset.variant) == -1 && getTotalBundleSize() < window.BundleSize){
            let button = parent.querySelector(".product-button");
            button.click();
        }
    }else{
        let quantity_selector = self.nextElementSibling;
        if(isInBundle(quantity_selector.dataset.variant) == -1 && getTotalBundleSize() < window.BundleSize){
            let variant_selector = document.querySelector(`.${self.dataset.handle}_variant_selector`);
            self.style.display = "none"
            if(variant_selector.length == 2){
                self.style.display = "block"
                // quantity_selector.style.display = "flex"
                window.BundleInfo.push(bundleProduct(self.dataset.default,self.dataset.img,Number(self.dataset.price)/100,1))
                updatSelectedData();
                self.parentElement.classList.add(self.dataset.handle + "-selected")
                console.log('adding... stuff')
            }else{
                variant_selector.style.display = "block"
                for(let i = 0; i < variant_selector.children.length; i++){
                    let child  = variant_selector.children[i];
                    child.removeAttribute('selected')
                }
                variant_selector.children[0].setAttribute('selected','')
            }

        }
    }

}

function changeQuantity(self){
    let isIncrementing = self.dataset.quantity_plus == "" ? true : false;
    let parent = self.parentElement;
    let quantity_display = parent.querySelector(".quantity-input");
    let bundle = window.BundleInfo[isInBundle(parent.dataset.variant)];
    let inventory = window.quantites.filter((variant) => variant.variantId == `${parent.dataset.variant}`)[0]
    console.log(inventory)
    console.log(inventory.quantity)
    if(isIncrementing){ 
        if( getTotalBundleSize() < window.BundleSize && bundle.quantity < inventory.quantity){
            bundle.quantity = `${Number(bundle.quantity) + 1}`;
        }
    }else{
        if(bundle.quantity != 1){
            bundle.quantity = `${Number(bundle.quantity) - 1}`;
        }else{
            parent.style.display = "";
            parent.previousElementSibling.style.display = "inline-block";
            let container = parent.previousElementSibling.parentElement;
            container.classList.remove(parent.previousElementSibling.dataset.handle + "-selected")
            window.BundleInfo.splice(isInBundle(parent.dataset.variant),1)
        }
        window.IsNotWarned = true;
    }

    quantity_display.value = bundle.quantity;
    quantity_display.setAttribute("value", bundle.quantity)
    updatSelectedData();

    if((window.BundleSize - getTotalBundleSize() == 0)){
        window.IsNotWarned = false;
    }

    setButtonState();
}

function bundleProduct(id,image,price,quantity){
    return JSON.parse(`{"variantId" : "${id}", "variantImage" : "${image}", "price" : "${price}", "quantity": "${quantity}"}`)
}

function isInBundle(id){
    let found = -1;
    let position = 0;
    window.BundleInfo.forEach((bundle) => {
        if(bundle.variantId == id){
            found = position;
        }
        position++;
    })
    return found;
}

function getTotalBundleSize(){
    let size = 0;
    for(let i = 0; i < window.BundleInfo.length; i++){
        let bundle = window.BundleInfo[i];
        size = Number(size) + Number(bundle.quantity);
    }
    return size;
}

function removeBundlerItem(element) {
    let img = element.previousElementSibling;
    let index = Array.from(img.parentNode.parentNode.children).indexOf(img.parentNode);

    window.BundleInfo.splice(isInBundle(element.dataset.remove), 1);

    img.src = window.placeholder_images[index % window.placeholder_images.length];
    element.removeAttribute('data-remove');
    element.style.display = "none";
    removeOldRemovalButtons();

setButtonState();  

updatSelectedData();
}

function removeOldRemovalButtons(){
    let images = document.querySelectorAll('.product-selected-placeholders');

    for(let i = 0; i < images.length; i++ ){
        let img = images[i];
        if(img.src.includes('placeholder')){
            let remove_button = img.nextElementSibling;
            remove_button.removeAttribute('data-remove');
            remove_button.style.display = "none"
        }

    }
}

function updateHeaderText() {
    let totalItemsNeeded = window.BundleSize - getTotalBundleSize();
    let headerText = document.querySelectorAll(".right_text_main");

    if (totalItemsNeeded <= 0 && getTotalBundleSize() > 0) { // Check if the bundle is complete or partially filled
        headerText.forEach(element => {
            element.innerHTML = "Bundle Complete!"; // or use `ADD 0 MORE PRODUCTS` if preferred
        });
    } else if (getTotalBundleSize() == 0) { // Reset to original when no products are in the bundle
        headerText.forEach(element => {
            element.innerHTML = window.originalHeaderText; // Use the stored original header text
        });
    } else { // Otherwise, ask to add more products
        headerText.forEach(element => {
            element.innerHTML = `ADD ${totalItemsNeeded} MORE ${totalItemsNeeded === 1 ? 'PRODUCT' : 'PRODUCTS'}`;
        });
    }
}

window.placeholder_images = [
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-1_200x.png?v=82680836825255707981765849054",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-2_200x.png?v=172943580824846899221765849055",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-3_200x.png?v=9196144944680286841765849055",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-4_200x.png?v=177906918868515401601765849055",
  
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-1st-2_200x.png?v=98178211547076937891765849056",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-2nd-2_200x.png?v=115573015504621094871765849056",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-3rd-2_200x.png?v=17784570349404456431765849054",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-4th-2_200x.png?v=41396826915142762781765849055"
];

function updatSelectedData() {
    // Update Placeholder Images
    let placeholders = document.querySelectorAll(".product-selected-placeholders, .product-selected-placeholder-mobile");

    // Determine the number of products currently in the bundler
    let numberOfProducts = getTotalBundleSize();

    // Loop through placeholders and update images accordingly
    for (let i = 0; i < placeholders.length; i++) {
        let placeholder = placeholders[i];

        if (numberOfProducts > 0) { // Check if at least one product is added
            switch (i) {
                case 0:
                    placeholder.src = window.placeholder_images[0]; // Keep the first image unchanged
                    break;
                case 1:
                    placeholder.src = "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-2nd_200x.png?v=21076560415882215721765849056";
                    break;
                case 2:
                    placeholder.src = "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-3rd_200x.png?v=91686536878293797211765849054";
                    break;
                case 3:
                    placeholder.src = "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-4th_200x.png?v=169772345990307328121765849055";
                    break;
                default:
                    placeholder.src = window.placeholder_images[i % window.placeholder_images.length];
                    break;
            }
        } else {
            // Reset to the original placeholders if no products are added
            placeholder.src = window.placeholder_images[i % window.placeholder_images.length];
        }
    }

    // Update selected product images and quantities
    let img_place = 0;
    for (let i = 0; i < window.BundleSize; i++) {
        let bundle = window.BundleInfo[i];
        if (bundle !== undefined) {
            for (let j = 0; j < Number(bundle.quantity); j++) {
                
                let desktopPlaceholder = document.getElementsByClassName("product-selected-placeholders")[img_place];
                let mobilePlaceholder = document.getElementsByClassName("product-selected-placeholder-mobile")[img_place];

                if (mobilePlaceholder.nextElementSibling.classList.contains("remove-item") && desktopPlaceholder.nextElementSibling.classList.contains("remove-item")) {
                    let removal_button_mobile = mobilePlaceholder.nextElementSibling;
                    let removal_button_desktop = desktopPlaceholder.nextElementSibling;
                    removal_button_mobile.style.display = "block";
                    removal_button_desktop.style.display = "block";

                    removal_button_mobile.setAttribute('data-remove', bundle.variantId);
                    removal_button_desktop.setAttribute('data-remove', bundle.variantId);
                }

                desktopPlaceholder.src = bundle.variantImage;
                mobilePlaceholder.src = bundle.variantImage;
                img_place++;
            }
        }
    }

    getTotalPrice();
    setButtonState();
  
updateSubTextVisibility();
  
  updateHeaderText();
  
}

function updateSubTextVisibility() {
    let rightTextSub = document.querySelector(".right_text_sub"); // Selector for the desktop version
    let rightTextSubMobile = document.querySelector(".right_text_sub_mobile"); // Selector for the mobile version

    let totalItems = getTotalBundleSize();
    if (totalItems >= window.BundleSize) {
        // Hide the sub texts when the bundle is complete
        if (rightTextSub) rightTextSub.style.display = 'none';
        if (rightTextSubMobile) rightTextSubMobile.style.display = 'none';
    } else {
        // Show the sub texts when the bundle is incomplete
        if (rightTextSub) rightTextSub.style.display = 'block';
        if (rightTextSubMobile) rightTextSubMobile.style.display = 'block';
    }
}



function setButtonState() {
    let atc_buttons = document.getElementsByClassName("product-button_atc");
    
    for (let i = 0; i < atc_buttons.length; i++) {
        let button = atc_buttons[i];
        let totalItems = getTotalBundleSize();
        let itemsNeededToAdd = window.BundleSize - totalItems;

        if (totalItems == 0) {
            button.innerHTML = "ADD A PRODUCT TO GET STARTED";
            button.setAttribute("disabled", "");
        } else if (totalItems >= window.BundleSize) {
            button.innerHTML = "BUY NOW";
            button.removeAttribute("disabled");
        } else {
            button.innerHTML = `ADD ${itemsNeededToAdd} MORE ${itemsNeededToAdd == 1 ? "PRODUCT" : "PRODUCTS"}`;
            button.removeAttribute("disabled");
        }
    }

    // Ensure the header text is also updated
    updateHeaderText();
}



function getTotalPrice(){
    let total = 0;
    let bundler = window.BundleInfo;

      for(let i = 0; i < bundler.length; i++){
        let bundle = window.BundleInfo[i];
        total = total + (Number(bundle.price) * Number(bundle.quantity))
      }

      document.getElementsByClassName("right_text_price")[0].innerHTML = `$${((total)- ((total) * 0.10)).toFixed(2)}`
      document.getElementsByClassName("right_text_price")[1].innerHTML = `$${((total)- ((total) * 0.10)).toFixed(2)}`

      if(getTotalBundleSize() == 4){
        document.getElementsByClassName("right_text_price")[0].innerHTML = `$${((total)- ((total) * 0.10)).toFixed(2)}`
        document.getElementsByClassName("right_text_price")[1].innerHTML = `$${((total)- ((total) * 0.10)).toFixed(2)}`
      }

      let retail_price = document.getElementsByClassName("price_retail");
      retail_price[0].innerHTML = `$${((total)).toFixed(2)}`
      retail_price[1].innerHTML = `$${((total)).toFixed(2)}`

      let price = ((total / 100)- ((total / 100) * 0.18)).toFixed(2);

      if(price == "0.00"){
        retail_price[0].style.display = "none";
        retail_price[1].style.display = "none";
      }else{
        retail_price[0].style.display = "block";
        retail_price[1].style.display = "block";
      }
      return `$${price}`;
  }

  function addBundlerItemsToCart(){
    
    window.BundleInfo.forEach((item)=>{
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {"id": item.variantId, "quantity": item.quantity, "properties": {}},
          dataType: 'json',
          async:false,
          success: function () {
            let cart_counts = document.getElementsByClassName("CartCount");
            for(let i = 0; i < cart_counts.length; i++){
                let count = cart_counts[i];
                let current_count = Number(count.innerHTML);
                count.innerHTML = current_count + 1;
            }
          }
        });
    })
    window.location.href = "/cart"

setButtonState();
  }


  function hideAddButtons(callback){
      let add_buttons = document.querySelectorAll(".product-button");

      add_buttons.forEach((button) =>{
          button.setAttribute("disabled","");
          button.style.opacity = 0.6;
      })
  }

  function showAddButtons(){
    let add_buttons = document.querySelectorAll(".product-button");

    add_buttons.forEach((button) =>{
        button.removeAttribute("disabled");
        button.style.opacity =1;
    })
}

function TriggerBundlerAddNotification() {
    let notiBar = document.getElementById("notification");
    notiBar.style.display = "flex";
    notiBar.classList.remove("animation");
    void notiBar.offsetHeight;
    notiBar.classList.add("animation");
}

document.addEventListener('scroll', function() {
    const $container = $('.product-selected-container');
    const scrollBottom = $container.parent().offset().top + $container.parent().height();
  if($(window).scrollTop() < $container.parent().offset().top) {
            $('.product-selected-container .sticky-right').css({'position': 'relative', 'top': '0'});
        $container.css({'align-self': 'flex-start', });
  }
    if($(window).scrollTop() > $container.parent().offset().top) {
        $('.product-selected-container .sticky-right').css({'position': 'fixed', 'top': '100px'});
    }
    if($(window).scrollTop() > scrollBottom - $('.product-selected-container .sticky-right').height() - 150) {
        $('.product-selected-container .sticky-right').css({'position': 'relative', 'top': '-50px', 'padding': '80px;'  });
        $container.css({'align-self': 'flex-end', });
    }
});